/**
 * Convierte un arreglo de empresas al formato de opciones 
 * compatible con los componentes de Dropdown.
 */

// Eliminadas las interfaces Project y Option

export function formatCompaniesToOptions(data) {
  // Verificación de seguridad para evitar errores si data no es un array
  if (!data || !Array.isArray(data)) return [];
  
  return data.map((project) => ({
    label: project.company_name,
    value: project.id,
  }));
}